import React from 'react'
import { useTranslation } from 'react-i18next'
import "./companyInformation.scss"


function CompanyInformation() {
    const { t } = useTranslation()

    return (
        <div className='container-company-info'>
            <div className='texts-company-info'>
                <h1>{t("security.company_info.title")}</h1>
                <p>{t("security.company_info.section_text_1")}</p>
                <p>{t("security.company_info.section_text_2")}</p>
                <p>{t("security.company_info.section_text_3")}</p>
            </div>
        </div>
    )
}

export default CompanyInformation